import "./Service.css";
import "../../machinelearning/MachineLearningCommon.css";
import Button from "../../machinelearning/button/Button";
import { Link, useNavigate } from "react-router-dom";

const Service = () => {
  return (
    <div id="service-metaverse" className="machinemainclass">
      <div className="sContainer">
        <div className="serviceContent">
          <h2>Connect with NFT Marketplace Development Experts</h2>
          <p>
          Turn your NFT marketplace vision into a high-performance platform. Book a free consultation with Web3 specialists today.
          </p>
          <div>
            <Link to="/contact_us" className="link">
              <Button arrowColor="purple" text="Book Your Free Consultation" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
